import {useState, useEffect} from "react";
import Collapse from "react-bootstrap/Collapse";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import axiApi from "ApiCaller";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import useCustomTranslation from "core/customTranslation";
import translations from "../translations";
import SearchSelect from "components/selects/SearchSelect";
import {useTranslation} from "react-i18next";

const FormFiltersModel = {
    uid: "",
    uuid: "",
    waste_type: "",
    download_type: "",
};
const ParamsModel = {
    groups: [],
    zones: [],
    islands: [],
    routes: [],
};

const ContainerListFilters = ({filters, applyFilters, setItemsShown}) => {
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [formFilters, setFormFilters] = useState({...FormFiltersModel});
    const {t: _TC} = useCustomTranslation(translations);
    const {t: _tT} = useTranslation("tags");
    const [params, setParams] = useState({...ParamsModel});

    useEffect(() => {
        getFilters();
    }, []);

    const getFilters = async () => {
        const resp = await axiApi.get("/api/recovery/filters/");
        if (resp.data) {
            setParams({
                waste_type: resp.data.waste_type,
                download_type: resp.data.download_type,
                groups: resp.data.groups,
                zones: resp.data.zones,
                islands: resp.data.islands,
            });
        }
    };

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        setFormFilters({...formFilters, [name]: value});
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };
    const onChangeSearcher = (e, actionMeta) => {
        let name = actionMeta.name;

        if (actionMeta.action === "select-option") {
            filters.current.chosen[name] = e.value;
        } else {
            delete filters.current.chosen[name];
        }
    };
    const handleClearFilters = () => {
        filters.current.chosen = {};
        setFormFilters({...FormFiltersModel});
        setItemsShown([]);
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;
        value = value.trim().toUpperCase();
        setFormFilters({...formFilters, [name]: value});
        filters.current.chosen[name] = value;
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    // console.log("filters.current", filters.current);

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{color: "black"}} className="col-1">
                        <FontAwesomeIcon icon="broom" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_tT("common.download")}
                        </label>
                        <DownloadTypesSelect multiple={false} value={formFilters.download_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_TC("filters.wasteType")}
                        </label>
                        <WasteTypesSelect multiple={false} value={formFilters.waste_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_TC("filters.groups")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _TC("filters.all")},
                                ...params.groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            name="group"
                            placeholder={_TC("filters.all")}
                            isClearable={true}
                            onChange={onChangeSearcher}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_TC("filters.zones")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _TC("filters.all")},

                                ...params.zones.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            name="zone"
                            placeholder={_TC("filters.all")}
                            isClearable={true}
                            onChange={onChangeSearcher}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{_TC("filters.islands")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: _TC("filters.all")},
                                ...params.islands.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            name="island"
                            placeholder={_TC("filters.all")}
                            isClearable={true}
                            onChange={onChangeSearcher}
                        />
                    </div>

                    <div className="col pt-3 mt-2">
                        <button type="button" onClick={applyFilters} className="btn btn-outline-primary me-3" title="Aplicar">
                            <FontAwesomeIcon icon="magnifying-glass" /> {_TC("filters.search")}
                        </button>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-1 h5 pt-3 text-center"></div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{_TC("filters.containerUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uid"
                            value={formFilters.uid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{_TC("filters.deviceUUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uuid"
                            value={formFilters.uuid}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default ContainerListFilters;
